// extracted by mini-css-extract-plugin
export var body = "_3e-1";
export var bodyPadded = "_3e-2";
export var chevron = "_3e-4";
export var chevronOpen = "_3e-5";
export var header = "_3e-0";
export var icon = "_3e-3";